import React from "react";
import { Check } from "lucide-react";
import { KATEGORI } from "@/lib/apiClient";

export const KategoriPicker = ({ value = [], onChange, testIdPrefix = "kategori" }) => {
  const toggle = (k) =>
    onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);

  const allSelected = value.length === KATEGORI.length;

  return (
    <div data-testid={`${testIdPrefix}-picker`}>
      <div className="flex flex-wrap gap-2">
        {KATEGORI.map((k) => {
          const active = value.includes(k);
          return (
            <button
              key={k}
              type="button"
              data-testid={`${testIdPrefix}-opt-${k.toLowerCase().replace(/\s/g, "-")}`}
              onClick={() => toggle(k)}
              className={`inline-flex items-center gap-1.5 rounded-full border px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider transition-colors duration-200 ${
                active
                  ? "border-blue-400/60 bg-blue-500/20 text-blue-200"
                  : "border-white/10 bg-slate-900/70 text-slate-400 hover:border-blue-400/30 hover:text-slate-200"
              }`}
            >
              {active && <Check className="w-3 h-3" />}
              {k}
            </button>
          );
        })}
      </div>
      <div className="mt-3 flex items-center gap-4 text-xs">
        <button
          type="button"
          data-testid={`${testIdPrefix}-select-all`}
          onClick={() => onChange(allSelected ? [] : [...KATEGORI])}
          className="text-blue-300 hover:text-blue-200 transition-colors duration-200"
        >
          {allSelected ? "Kosongkan semua" : "Pilih semua kategori"}
        </button>
        <span className="text-slate-500">{value.length} kategori dipilih</span>
      </div>
    </div>
  );
};
